export const CompanySubscriptionType = Object.freeze({
  1: "Professional",
  2: "Enterprise",
  3: "Premium",
});
